import { render, staticRenderFns } from "./order-history.vue?vue&type=template&id=fe5b770c&scoped=true&"
import script from "./order-history.vue?vue&type=script&lang=js&"
export * from "./order-history.vue?vue&type=script&lang=js&"
import style0 from "./order-history.vue?vue&type=style&index=0&id=fe5b770c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5b770c",
  null
  
)

export default component.exports